import { Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface ISiteSettings {
  readonly brokerageCompany: IAssociatedContact
  readonly id: string
}

const SiteSettingsRecord = Record({
  brokerageCompany: new AssociatedContact(),
  id: '',
})

export class SiteSettings extends SiteSettingsRecord implements ISiteSettings {
  public static fromJS(initialState?: Partial<ISiteSettings>) {
    if (!initialState) {
      return new SiteSettings()
    }

    const { brokerageCompany, ...rest } = initialState

    return new SiteSettings({
      brokerageCompany: AssociatedContact.fromJS(brokerageCompany),
      ...rest,
    })
  }

  public readonly brokerageCompany: AssociatedContact
  public readonly id: string

  constructor(props?: Partial<SiteSettings>) {
    props ? super(props) : super()
  }
}
